module.exports = __webpack_public_path__ + "static/media/fav.35c6500b.png";